import { RolePermission } from "@core/types";

export const DEVICE_ACTION_LIST = {
    configuration: {
        name: "Configuration",
        translateKey: "DEVICE_DROPDOWN.CONFIGURATION",
        icon: "icon-settings",
        privilegedId: RolePermission.DEVICE_CFG
    },
    analysis: {
        name: "Analysis",
        translateKey: "DEVICE_DROPDOWN.ANALYSIS",
        icon: "icon-bar-chart",
        privilegedId: RolePermission.DEVICE_ANALYSIS
    },
    editDeviceInfo: {
        name: "Edit Device Information",
        translateKey: "DEVICE_DROPDOWN.EDIT_DEVICE_INFORMATION",
        icon: "icon-edit",
        privilegedId: RolePermission.DEVICE_EDIT
    },
    alertPolicy: {
        name: "Alert Policy",
        translateKey: "DEVICE_DROPDOWN.ALERT_POLICY",
        icon: "icon-alert-circle",
        privilegedId: RolePermission.FEATURES_ALERT
    },
    editTags: {
        name: "Edit Tags",
        translateKey: "DEVICE_DROPDOWN.EDIT_TAGS",
        icon: "icon-tag",
        privilegedId: RolePermission.DEVICE_EDIT
    },
    assignGroup: {
        name: "Assign Group",
        translateKey: "DEVICE_DROPDOWN.ASSIGN_GROUP",
        icon: "icon-briefcase",
        privilegedId: RolePermission.ADMIN_ACCESS
    },
    deleteDevice: {
        name: "Delete Device(s)",
        translateKey: "DEVICE_DROPDOWN.DELETE_DEVICES",
        icon: "icon-delete",
        privilegedId: RolePermission.DEVICE_DELETE
    },
    webGui: {
        name: "Remote Access GUI",
        translateKey: "DEVICE_DROPDOWN.REMOTE_ACCESS_GUI",
        icon: "icon-chrome",
        privilegedId: RolePermission.DEVICE_REMOTE_ACCESS
    }/* ,
    ssh: {
        name: "Remote Access Shell",
        icon: "icon-lock",
        privilegedId: 'DeviceRemoteAccess'
    } */
};
